<div class="modal">
  <div class="card card--xl">
    <div class="card-header d-flex justify-content-between">
      <h3 class="card-title">Zahtevi obrađeni za ponudu</h3>

      <div class="d-flex align-items-center ms-auto me-3">
        <app-dropdown [options]="filteredUsers"
                      [title]="userTitle"
                      [parentForm]="form"
                      [parentControl]="'userId'"
                      [showAll]="true"
                      class="me-3"></app-dropdown>
        <app-search (search)="onSearch($event)"></app-search>
      </div>
    </div>

    <div class="card-body">
      <div class="table-scroll-container">
        <table class="table table-hover table-vcenter card-table table-sticky">
          <thead>
          <tr>
            <th class="width-5"></th>
            <th class="width-35">Radni nalog</th>
            <th class="width-25">Delegirano</th>
            <th class="width-20">Rokovi</th>
            <th class="width-25">Status</th>
          </tr>
          </thead>
          <tbody>
              <tr class="pointer"
                  *ngFor="let request of requests; let i = index"
                  (click)="onSelectRequest(request)">
            <td>
              <i class="fa fa-check-circle"
                 [class.text-green]="selectedRequestIds?.includes(request.workRequestId)"></i></td>
            <td>
              <div>{{ request.clientName }}</div>
              <div>{{ request.client }}</div>
              <div>{{ request.name }}</div>
              <div class="fw-bold">{{ request.upisId }}</div>
              <div>{{ request.quantity | digitFormat }} {{ request.unit }}</div>
              <div class="d-flex">
                <div *ngIf="request.contactName" class="me-3">
                  <i class="fa fa-address-card me-1"></i>
                  {{ request.contactName }}
                </div>
                <div *ngIf="request.contactPhone">
                  <i class="fa fa-phone me-1"></i>
                  {{ request.contactPhone }}
                </div>
              </div>
            </td>
            <td>
              <div class="media align-items-center mb-1" *ngFor="let assignee of request.assignees">
                <div class="avatar avatar-sm me-2"
                     [ngStyle]="{'background-image':'url(' + assignee.photo + ')'}"></div>
                <div class="media-body">
                  <div>{{ assignee.name }}</div>
                  <div class="small text-muted">
                    {{ assignee.comment || '/' }}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center mb-1" tooltipStr="Datum prijema zahteva" *ngIf="request.receiptOfRequestDate">
                {{ request.receiptOfRequestDate | date:'dd/MM/yyyy' }}
                <i class="fa fa-folder-open ms-2"></i>
              </div>
              <div class="d-flex align-items-center mb-1" tooltipStr="Rok za dostavljanje ponude" *ngIf="request.offerDeadline">
                {{ request.offerDeadline | date:'dd/MM/yyyy' }}
                <i class="fa fa-envelope-open-text ms-2"></i>
              </div>
              <div class="d-flex align-items-center" tooltipStr="Rok za isporuku:" *ngIf="request.deliveryDeadline">
                {{ request.deliveryDeadline | date:'dd/MM/yyyy' }}
                <i class="fa fa-truck ms-2"></i>
              </div>
            </td>
            <td>
              <div class="d-flex my-2">
                <i class="fa fa-drafting-compass me-2"
                   [class.text-green]="request.requestJobType?.includes('Inženjerski')"
                   tooltipStr="Inženjerski"
                ></i>
                <i class="fa fa-paint-brush me-2"
                   [class.text-green]="request.requestJobType?.includes('Grafički')"
                   tooltipStr="Grafički"
                ></i>
              </div>
              <div class="d-flex my-2">
                <i class="fa fa-file-alt me-2"
                   [class.text-green]="request.documentationListStatus === 'Approved'"
                   [class.text-orange]="request.documentationListStatus === 'ForApproval'"
                   tooltipStr="Status dokumentacije"
                ></i>
                <i class="fa fa-box me-2"
                   [class.text-green]="request.materialsListStatus === 'Approved'"
                   [class.text-orange]="request.materialsListStatus === 'ForApproval'"
                   tooltipStr="Status materijala"
                ></i>
                <i class="fa fa-hammer"
                   [class.text-green]="request.operationsListStatus === 'Approved'"
                   [class.text-orange]="request.operationsListStatus === 'ForApproval'"
                   tooltipStr="Status operacija"
                ></i>
              </div>
              <div>
                <app-sector-tag [sectors]="request.sectors"></app-sector-tag>
              </div>
            </td>
          </tr>
            </tbody>
        </table>
      </div>
      <app-empty *ngIf="isListEmpty"></app-empty>
    </div>


    <div class="card-footer bg-white text-end">
      <button class="btn btn-secondary btn-question me-2" (click)="emitFalse()">Odustani</button>
      <button class="btn btn-success btn-question" (click)="onSave()">Dodaj</button>
    </div>
  </div>
</div>
